import React from "react";
import { Alert } from "react-bootstrap";
import { Problem, ValidationProblem } from "../api/backendApi";

interface ErrorDisplayProps {
  error: Problem | string | undefined;
}

function isString(data: unknown): data is string {
  return typeof data === "string";
}

function ErrorDisplay({ error }: ErrorDisplayProps) {
  let messages: string[] | undefined = undefined;

  if (error) {
    if (isString(error)) {
      messages = [error as string];
    } else {
      const problem = error as Problem;

      if (problem.type === "crsbuilder/validation") {
        const validationProblem = problem as ValidationProblem;

        messages = Object.keys(validationProblem.validation).map((k) =>
          validationProblem.validation[k].join(", "),
        );
      } else {
        messages = [problem.title];

        if (problem.instance) messages[0] += ` [${problem.instance}]`;
      }
    }
  }

  return messages ? (
    <Alert variant="danger">
      {messages.map((message, index) => (
        <p key={index}>
          <span className="icon-alert inverse "></span>
          {message}
        </p>
      ))}
    </Alert>
  ) : (
    <></>
  );
}

export default ErrorDisplay;
